import { combineReducers } from 'redux';
import entities from './entities';

export const rootReducer = (routerReducer) =>
  combineReducers({
    router: routerReducer,
    entities,
  });
